import React from 'react'
import { Link } from 'react-router-dom'
import { useInternationalization } from '../../../features/i18n'

const label = {
  thank_you: {
    en: 'Thank You!',
    id: 'Terima Kasih!'
  },
  back: {
    en: 'Back to KHUB site',
    id: 'Kembali ke KHUB'
  }
}

const Content = () => {
  const { translate, language } = useInternationalization()

  return (
    <div className="w-full md:w-8/12 lg:w-10/12 mx-auto h-screen flex items-center">
      <div className="p-5 md:p-10 lg:p-20 w-full bg-white lg:rounded h-full lg:h-auto flex items-center">
        <div className="flex flex-wrap items-center -mx-4">
          <div className="mx-auto lg:mx-0 w-3/4 lg:w-1/2 mb-10 lg:mb-0 px-4 h-auto lg:pt-2">
            <img src="/images/khub_confirmation.png" alt="KHUB illustration for register confirmation" className="mx-auto"/>
          </div>
          <div className="w-full lg:w-1/2 px-4 text-center lg:text-left">
            <h1 className="text-xl lg:text-2xl font-bold mb-2 font-primary">{label.thank_you[language.name]}</h1>
            <p className="text-sm text-gray-444 mb-8">
              {translate('REGISTRATION', 'confirmation')}
            </p>
            <p className="text-sm">
              <Link to="/" className="link underline">{label.back[language.name]}</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export { Content }
